import { serialize } from "@packages/core";

type Convert1<T> = T extends string | number | boolean | bigint | null | undefined
  ? T
  : { [K in keyof T]: Convert2<T[K]> };
type Convert2<T> = T extends string | number | boolean | bigint | null | undefined ? T : string;
type Map<T> = T extends [infer U, ...infer V] ? [Convert1<U>, ...Map<V>] : [];

export function QueryKey<T extends ReadonlyArray<any>>(...parameters: T): Map<T> {
  return parameters.map(function (parameter) {
    return typeof parameter === "object" && parameter !== null
      ? Object.fromEntries(
          Object.entries(parameter).map(function ([key, value]) {
            return typeof value === "object" && value !== null
              ? [key, JSON.stringify(serialize(value))]
              : [key, value];
          }),
        )
      : parameter;
  }) as any;
}
